import Box from '@mui/material/Box';

import { Grid2 } from '@mui/material';
import { ReactComponent as ExpandIcon } from '../../../assets/expand-icon.svg';
import mapRoadmap from '../../../assets/map-roadmap.png';
import mapSatellite from '../../../assets/map-satellite.png';
import { ReactComponent as MinusIcon } from '../../../assets/minus-icon.svg';
import { ReactComponent as PlusIcon } from '../../../assets/plus-icon.svg';
import { MAP_TYPES } from '../../../constants/map.constants';
import {
    ActionBox,
    ActionBoxExpand,
    ActionBoxZoomIn,
    ActionBoxZoomOut,
    ActionsBar,
} from './map-actions-side-bar.styles';

const MapActionsSideBar = ({
    mapType,
    onExpandButtonClick,
    onMapTypeButtonClick,
    onMapZoomInButtonClick,
    onMapZoomOutButtonClick,
}: {
    mapType: MAP_TYPES;
    onExpandButtonClick: () => void;
    onMapTypeButtonClick: (newMapType: MAP_TYPES) => void;
    onMapZoomInButtonClick: () => void;
    onMapZoomOutButtonClick: () => void;
}) => {
    return (
        <ActionsBar>
            <ActionBoxExpand onClick={onExpandButtonClick}>
                <ExpandIcon />
            </ActionBoxExpand>
            <Box height={'12px'} />
            <Box>
                <Grid2 container>
                    <Grid2 size={6}>
                        <ActionBox
                            onClick={() => onMapTypeButtonClick(mapType)}
                            sx={{
                                backgroundImage:
                                    mapType === MAP_TYPES.SATELLITE
                                        ? `url(${mapRoadmap})`
                                        : `url(${mapSatellite})`,
                                backgroundSize: 'cover',
                            }}
                        />
                    </Grid2>
                </Grid2>
            </Box>
            <Box height={'12px'} />
            <ActionBoxZoomIn onClick={onMapZoomInButtonClick}>
                <PlusIcon />
            </ActionBoxZoomIn>
            <ActionBoxZoomOut onClick={onMapZoomOutButtonClick}>
                <MinusIcon />
            </ActionBoxZoomOut>
        </ActionsBar>
    );
};

export default MapActionsSideBar;
